import { useEffect, useState } from 'react';

/**
 * 检测当前设备是否支持 WebXR immersive-vr。
 * 仅在支持 VR 的设备上返回 true，用于决定是否显示 VR 入口按钮。
 */
export function useXrSupported(): boolean {
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    if (!navigator.xr) return;

    let cancelled = false;

    void navigator.xr
      .isSessionSupported('immersive-vr')
      .then((vr) => {
        if (!cancelled) setSupported(vr);
      })
      .catch(() => {
        if (!cancelled) setSupported(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return supported;
}
